import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { RequisitionData } from '@core/tellent-assistant-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

type RequisitionStatus = RequisitionData['status'];

const STATUS_LABEL: Record<RequisitionStatus, string> = {
  draft: 'Draft',
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  filled: 'Filled',
};

@Component({
  selector: 'rt-list-item-requisition',
  imports: [ListCardComponent, IconContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-requisition.component.html',
  styleUrl: './list-item-requisition.component.less',
})
export class ListItemRequisitionComponent {
  protected readonly statusLabel = computed(() => STATUS_LABEL[this.data().status]);

  public readonly data = input.required<RequisitionData>();
}
